<div class="ActionButton__wrapper">
  <button
    type="button"
    class="ActionButton"
    (click)="buttonClicked()"
    [disabled]="isDisabled"
    [ngClass]="{
      'ActionButton--fit': actionButtonConfig?.size === buttonSizes.fit,
      'ActionButton--fullWidth':
        actionButtonConfig?.size === buttonSizes.fullWidth,
      'ActionButton--special':
        actionButtonConfig?.level &&
        actionButtonConfig?.level === buttonLevels.special,
      'ActionButton--high':
        actionButtonConfig?.level &&
        actionButtonConfig?.level === buttonLevels.high,
      'ActionButton--medium':
        actionButtonConfig?.level &&
        actionButtonConfig?.level === buttonLevels.medium,
      'ActionButton--low':
        actionButtonConfig?.level &&
        actionButtonConfig?.level === buttonLevels.low,
      'ActionButton--text':
        actionButtonConfig?.level &&
        actionButtonConfig?.level === buttonLevels.text,
      'ActionButton--error':
        actionButtonConfig?.level &&
        actionButtonConfig?.level === buttonLevels.error,
      'ActionButton--icon':
        actionButtonConfig?.icon && !actionButtonConfig?.content,
      'is-active': actionButtonConfig?.active,
    }"
    tabindex="0"
    (keydown.enter)="buttonClicked()"
    [attr.aria-label]="actionButtonConfig?.label"
  >
    <div class="ActionButton__content">
      @if (actionButtonConfig?.leftIcon) {
        <icon
          class="ActionButton__icon"
          [name]="actionButtonConfig.leftIcon"
          [config]="{ fill: iconFill }"
        >
        </icon>
      }
      <span
        class="ActionButton__label--text"
        [innerHTML]="actionButtonConfig.label || 'Actions'"
      >
      </span>
      <icon
        class="ActionButton__icon"
        [name]="actionButtonConfig?.rightIcon || 'carat_down'"
        [ngClass]="{ 'ActionButton__icon-rotate': showSubnav }"
        [config]="{ fill: iconFill }"
      >
      </icon>
    </div>
  </button>
  @if (showSubnav) {
    <div class="ActionButton__subnav">
      @for (subnavItem of actionsConfig; track subnavItem) {
        <div class="ActionButton__subnav-row">
          <ds-link
            [linkConfig]="subnavItem"
            (linkClicked)="handleLinkClicked($event)"
            [externalSiteModalConfig]="externalSiteModalConfig"
          >
            <button class="ActionButton__subnav-link">
              <p
                dataClickEvent
                [attr.aria-label]="subnavItem.label"
                [innerHTML]="subnavItem.label"
                class="ActionButton__subnav-label"
              ></p>
              @if (subnavItem.icon) {
                <icon [name]="subnavItem.icon || 'caret_down'"> </icon>
              }
            </button>
          </ds-link>
        </div>
      }
    </div>
  }
</div>
